<template>
    <div :is="navigation && enabled ? 'router-link' : 'button'" @click.stop="clicked"
    :class="(enabled?'cursor-pointer ':'cursor-not-allowed ') + btnColoring + ' ' + btnStyling"
    class="m-t-s rounded-[.5em] text-center select-none transition-colors"
    :to="navigation">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'btnSubmit',
    props: ['enabled', 'btnColor', 'btnStyle', 'navigation'],
    computed:{
        btnColoring(){
            if(!this.enabled){
                return "bg-gray text-white border border-gray "
            }
            switch (this.btnColor) {
                case 'red': return "bg-red-90 text-white hover:text-red-90 hover:bg-white border border-red ";
                case 'red-border': return "bg-white text-red-90 hover:text-white hover:bg-red-90 border border-red-90 ";
                case 'orange-border': return "border border-orange-100 bg-white text-orange-100 hover:bg-orange-100 hover:text-white ";
                case 'blue': return "border border-blue-100 bg-blue-100 text-white hover:bg-white hover:text-blue-100 ";
                case 'blue-border': return 'border bg-white text-blue-100 border-blue-100 hover:bg-blue-100 hover:text-white ';
                case 'green': return "border border-green-80 bg-green-80 text-white hover:bg-white hover:text-green-80 ";
                case 'simple-red': return "text-red-90 text-left";
                case 'simple-green': return "text-green-80 text-left";
                case 'simple-orange': return "text-orange-100 text-left";
                case 'simple-blue': return "text-blue-100 text-left";
                default: return "border border-orange-100 bg-orange-100 text-white hover:bg-white hover:text-orange-100 ";
            }
        },
        btnStyling(){
            if (this.btnStyle) {
                return this.btnStyle
            }
            else {
                return "py-[.5em] px-[1.5em]";
            }
        }
    },
    methods:{
        clicked(){
            if(this.enabled){
                this.$emit('clicked')
            }
        }
    }
}
</script>

<style scoped>
</style>